import { mergeWith } from 'lodash-es';

const mergeRouteQuery = (to, from) => {
  return mergeWith(from.query, to.query);
};

const pushWithRouteQuery = ({ router, to, from }) => {
  router.push({ ...to, query: mergeRouteQuery(to, from) });
};

const replaceWithRouteQuery = ({ router, to, from }) => {
  router.replace({ ...to, query: mergeRouteQuery(to, from) });
};

export { pushWithRouteQuery, mergeRouteQuery, replaceWithRouteQuery };
